import BaseService from './BaseService'

class VideosService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  getGIF = async (url: string, locationId: string) =>
    this.requests.get(`/gif?locationId=${locationId}&url=${url}`)
}

console.log(
  `BaseService.servicesConfig.Videos`,
  BaseService.servicesConfig.Videos
)

const instance = new VideosService(BaseService.servicesConfig.Videos)

export default instance
